import React, { useCallback } from 'react';
import useVertical from '@app/catalog/hooks/useVertical';
import { PageSwitcherTypes } from '../../data';
import { SwitcherLink } from './components';
import type { LinkProps } from './types';

export const BrowseSwitcherLink = ({
  children,
  to,
  onClick,
  ...props
}: LinkProps) => {
  const { updatedVertical = '', ...rest } = props;
  const [, setCurrentVertical] = useVertical();
  // handle switcherlink onclick
  const handleOnClick = useCallback(() => {
    if (updatedVertical) {
      setCurrentVertical(updatedVertical);
    }

    if (typeof onClick === 'function') {
      // go on with
      onClick();
    }
  }, [onClick, setCurrentVertical, updatedVertical]);

  return (
    <SwitcherLink
      as={PageSwitcherTypes.Browse}
      to={to}
      onClick={handleOnClick}
      {...rest}
    >
      {children}
    </SwitcherLink>
  );
};

export default BrowseSwitcherLink;
